import { useState } from 'react';
import RentPriceInfoStep from '@/components/ui/RentPrice/InfoStep';
import RentPriceResultStep from '@/components/ui/RentPrice/ResultStep';
import RentPriceInputStep from '@/components/ui/RentPrice/InputStep';
import { ResultData } from './rentLimits';
import { RentPriceCalculatorStep } from '../../../pages/[lang]/mietpreis-rechner';

type RentPriceStepperProps = {
  step: RentPriceCalculatorStep;
  onStepChange: (step: RentPriceCalculatorStep) => void;
};

const RentPriceStepper = ({ step, onStepChange }: RentPriceStepperProps) => {
  const [dataForCalculator, setDataForCalculator] = useState<ResultData | null>(null);

  return (
    <div className="mt-16 flex flex-col mx-auto prose text-black">
      {(() => {
        switch (step) {
          case 'info':
            return <RentPriceInfoStep onNext={() => onStepChange('input')} />;
          case 'input':
            return (
              <RentPriceInputStep
                initData={dataForCalculator}
                onFinished={(data) => {
                  setDataForCalculator(data);
                  onStepChange('result');
                }}
              />
            );
          case 'result':
            return dataForCalculator && <RentPriceResultStep inputData={dataForCalculator} />;
        }
      })()}
    </div>
  );
};

export default RentPriceStepper;
